import React, { useState, useEffect } from "react";
import {
  useTable,
  useFilters,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import { SERVER_BASE } from "../config/server";
import apiClient from "../utils/apiClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThumbsUp,
  faEllipsisV,
  faEye,
  faPaperPlane,
  faPlus,
  faPen,
  faCheckCircle,
  faEdit,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ApproverModal from "./ApproverModal";
import moment from "moment";
const GlobalFilter = ({ filter, setFilter }) => (
  <div className="w-100">
    <input
      value={filter || ""}
      placeholder="Search..."
      className="form-control"
      onChange={(e) => setFilter(e.target.value || undefined)}
    />
  </div>
);

const IssueRequestTable = ({ accessOfDepartments, permissions }) => {
  const closeModal = () => {
    setModalShow(false); // Close the modal
  };
  const [activeTab, setActiveTab] = useState("table1");
  const navigate = useNavigate();
  const [draftId, setDraftID] = useState(null);
  const [profileDetails, setProfileDetails] = useState(null); // State for profile details
  const token = localStorage.getItem("token");
  const code = localStorage.getItem("code");
  const email = localStorage.getItem("email");
  const name = localStorage.getItem("name");
  const badgeId = localStorage.getItem("badgeId");
  const pin = localStorage.getItem("pin");
  const [personOptions, setPersonOptions] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [departmentForModal, setDepartmentForModal] = useState(null);
  const [issueRequests, setIssueRequests] = useState([]);

  useEffect(() => {
    apiClient
      .get(`${SERVER_BASE}/getIssueRequests`)
      .then((response) => {
        const filtered = response.data.filter(
          (request) =>
            accessOfDepartments.includes(request.receivingDepartment) ||
            accessOfDepartments.includes(request.issuerDepartment)
        );
        setIssueRequests(filtered);
      })
      .catch((err) =>
        console.error("Error fetching issue requests:", err)
      );
  }, [accessOfDepartments]);

  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, {
        params: { email },
      });
      setProfileDetails(response.data[0] || null); // Safely set profile details
    } catch (err) {
      console.error("Error fetching profile details:", err);
      setProfileDetails(null); // Handle error gracefully
    }
  };
  useEffect(() => {
    fetchProfileDetails();
  }, []);
  useEffect(() => {
    const fetchPersons = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getApprovers`, { // Assuming there's an endpoint to fetch persons
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          }
        });
        setPersonOptions(
          response.data.map((person) => ({
            value: person.id,
            label: `${person.firstName} ${person.lastName} - ${person.contactNo}`,
            // Assuming 'firstName' and 'lastName' are available
            mobileNo: person.contactNo,
            badgeId: person.badgeId,
            position: person.position,
            sewadarOf: person.sewadarOf
          }))
        );

      } catch (error) {
        console.error('Error fetching persons for approval:', error);
      }
    };
    fetchPersons();
  }, []);
  const TableComponent = ({ columns, data }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      page,
      nextPage,
      previousPage,
      canNextPage,
      canPreviousPage,
      pageOptions,
      gotoPage,
      setPageSize,
      state,
      setGlobalFilter,
    } = useTable(
      {
        columns,
        data,
      },
      useFilters,
      useGlobalFilter,
      useSortBy,
      usePagination
    );

    const { pageIndex, pageSize, globalFilter } = state;

    return (
      <div>
        <div className="d-flex justify-content-between gap-2 mb-3">
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />

          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            className="form-select form-select-sm"
            style={{ width: "auto" }}
          >
            {[10, 20, 30, 40, 50].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </div>
        <table {...getTableProps()} className="table table-striped" style={{ fontSize: '14px' }}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="pagination d-flex align-items-center justify-content-between  bg-light ">
          {/* Left Section: Next and Previous Buttons */}

          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="btn btn-secondary"
          >
            Previous
          </button>
          <span>
            Page{" "}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="btn btn-secondary "
          >
            Next
          </button>
        </div>
      </div>
    );
  };
  const handleInformIncharge = (row) => {
    // 🔍 Find Main Incharge of Receiving Department
    const incharge = personOptions.find(
      (p) =>
        p.sewadarOf === row.receivingDepartment &&
        p.position === "Main Incharge"
    );

    if (!incharge || !incharge.mobileNo) {
      Swal.fire({
        icon: "error",
        text: "Main Incharge mobile number not found",
        toast: true,
        position: "top-end",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    const phone = incharge.mobileNo.replace(/\D/g, "");

    /* ================= MESSAGE ================= */
    let message = `Below is the Approved Quantity of the requested items.\n\n`;

    message += `Request No: ${row.requestNumber}\n`;
    message += `Department: ${row.receivingDepartment}\n\n`;

    /* ================= ITEMS ================= */
    row.items.forEach((item, index) => {
      message += `${index + 1}. ${item.itemName || item.item}\n`;
      message += `   Requested Qty : ${item.quantity} ${item.uom || ""}\n`;
      message += `   Approved Qty  : ${item.approvedQuantity} ${item.uom || ""}\n\n`;
    });

    /* ================= LINK ================= */
    const draftId = row.id;
    const baseLink = `https://rs.iosystem.in/IssueRequestPreview?id=${draftId}`;
    const fullLink = `${baseLink}&draftId=${draftId}&type=issueRequest`;

    message += "For more details, view here:\n";
    message += fullLink;

    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };


  const Table1 = () => {
    const [data, setData] = useState([]);
    const pendingData = React.useMemo(() => {
      return issueRequests.filter(
        (req) => req.status === "Pending" || req.status === "Approved"
      );
    }, [issueRequests]);


    const columns = React.useMemo(
      () => [
        { Header: "RQ No", accessor: "requestNumber" },
        { Header: "Requesting", accessor: "receivingDepartment" },
        { Header: "Issuing", accessor: "issuerDepartment" },
        {
          Header: "Project", accessor: "projectName", Cell: ({ value }) => {
            const display = value ? value : 'Regular';
            return display
          }
        },
        {
          Header: "Items",
          accessor: "items",
          Cell: ({ value }) => {
            if (!Array.isArray(value) || value.length === 0) return "-";

            return value
              .map(i => i.item || i.itemName || i.printName)
              .filter(Boolean)
              .join(", ");
          }
        },
        { Header: "Remarks", accessor: "remarks" },
        { Header: "Status", accessor: "status" },
        // { Header: "Items", accessor: "items" },
        {
          Header: "Preview",
          accessor: "Preview",
          Cell: ({ row }) => {
            return (
              <div className="d-flex gap-1">
                {/* VIEW */}
                {permissions?.read && (
                  <button
                    className="btn btn-sm btn-outline-success"
                    onClick={() => handleView(row.original)}
                  >
                    View
                  </button>
                )}

                {/* EDIT */}
                {permissions?.edit && (
                  <button
                    className="btn btn-sm btn-outline-success"
                    onClick={() =>
                      navigate("../issueRequestPage", {
                        state: { id: row.original.id },
                      })
                    }
                  >
                    <FontAwesomeIcon icon={faLock} className="" />

                  </button>
                )}
                {permissions?.read && (
                  <button
                    className="btn btn-sm btn-outline-success"
                    onClick={() => handleInformIncharge(row.original)}
                  >
                    <FontAwesomeIcon icon={faPaperPlane} className="me-2 text-success" />
                    Inform
                  </button>
                )}
              </div>
            );
          },
        },
        {
          Header: "#",
          accessor: "actions",
          Cell: ({ row }) => (

            <div className="dropdown">
              {/* {permissions?.read &&
                 
                    <button
                      className="btn btn-sm btn-outline-success me-1"
                      onClick={() => handleView(row.original)}
                    >
                      View
                    </button>
                 
                } */}
              <button
                className="btn btn-light btn-sm"
                type="button"
                id={`dropdownMenuButton-${row.index}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby={`dropdownMenuButton-${row.index}`}
              >
                {/* {row.original.status == "Approved" &&
                  (permissions?.edit) && (
                    <>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() =>
                            navigate("../issueRequestPage", {
                              state: {
                                id: row.original.id,
                              },
                            })
                          }
                        >
                          <FontAwesomeIcon icon={faEdit} /> Edit
                        </button>
                      </li>
                    </>
                  )} 
                  {row.original.status != "Approved" &&
                  (permissions?.read || permissions?.write) && (
                    <>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() =>
                            handleSendForApproval(
                              row.original.id,
                              row.original.receivingDepartment
                            )
                          }
                        >
                          <FontAwesomeIcon icon={faPaperPlane} /> Send for
                          Approval
                        </button>
                      </li>
                    </>
                  )}
                <li>
                  {row.original.status != "Approved" &&
                    (permissions?.read || permissions?.write) && (
                      <>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() =>
                              handleApprove(
                                row.original.id
                              )
                            }
                          >
                            <FontAwesomeIcon icon={faThumbsUp} /> Self Approve
                          </button>
                        </li>
                      </>
                    )}
                  <hr className="dropdown-divider" />
                </li> */}

                {/* Created By / Updated By */}

                <li>
                  <span className="dropdown-item-text text-muted">
                    <FontAwesomeIcon icon={faPlus} />{" "}
                    {row.original.createdBy
                      ? `${row.original.createdBy} (${row.original.created_at
                        ? moment(row.original.created_at).format(
                          "DD-MMM-YY hh:mm A"
                        )
                        : ""
                      })`
                      : ""}
                  </span>
                </li>
                {row.original.updatedAt && (
                  <li>
                    <span className="dropdown-item-text text-muted">
                      <FontAwesomeIcon icon={faPen} />{" "}
                      {row.original.updatedAt
                        ? `${row.original.updatedBy} (${row.original?.updatedAt
                          ? moment(row.original?.updatedAt).format(
                            "DD-MMM-YY hh:mm A"
                          )
                          : ""
                        })`
                        : ""}
                    </span>
                  </li>
                )}
                {row.original.approvedBy && (
                  <li>
                    <span className="dropdown-item-text text-muted">
                      <FontAwesomeIcon icon={faCheckCircle} />{" "}
                      {row.original.approvedBy
                        ? `${row.original.approvedBy} (${row.original?.approvedAt
                          ? moment(row.original?.approvedAt).format(
                            "DD-MMM-YY hh:mm A"
                          )
                          : ""
                        })`
                        : ""}
                    </span>
                  </li>
                )}

              </ul>
            </div>
          ),
        },
      ],
      [permissions]
    );

    return <TableComponent columns={columns} data={pendingData} />;
  };

  const Table2 = () => {
    const completedData = React.useMemo(() => {
      return issueRequests.filter(
        (req) => req.status !== "Pending" && req.status !== "Approved"
      );
    }, [issueRequests]);

    const columns = React.useMemo(
      () => [
        { Header: "RQ No", accessor: "requestNumber" },
        // { Header: "IS Number", accessor: "issueSlipCode" },
        { Header: "Requesting", accessor: "receivingDepartment" },
        { Header: "Issuing", accessor: "issuerDepartment" },
        {
          Header: "Project", accessor: "projectName", Cell: ({ value }) => {
            const display = value ? value : 'Regular';
            return display
          }
        },
        {
          Header: "Items",
          accessor: "items",
          Cell: ({ value }) => {
            if (!Array.isArray(value) || value.length === 0) return "-";

            return value
              .map(i => i.item || i.itemName || i.printName)
              .filter(Boolean)
              .join(", ");
          }
        },
        { Header: "Remarks", accessor: "remarks" },
        { Header: "Status", accessor: "status" },
        // { Header: "Items", accessor: "items" },
        {
          Header: "Preview",
          accessor: "Preview",
          Cell: ({ row }) => {
            return (
              permissions?.read && (
                <button
                  className="btn btn-sm btn-outline-success me-1"
                  onClick={() => handleView(row.original)}
                >
                  View
                </button>
              )
            );
          },
        },
        {
          Header: "#",
          accessor: "actions",
          Cell: ({ row }) => (
            <div className="dropdown">
              <button
                className="btn btn-light"
                type="button"
                id={`dropdownMenuButton-${row.index}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby={`dropdownMenuButton-${row.index}`}
              >
                {/* {permissions?.read &&
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleView(row.original)}
                    >
                      <FontAwesomeIcon icon={faEye} /> Preview
                    </button>
                  </li>
                } */}
                <li>
                  <hr className="dropdown-divider" />
                </li>

                {/* Created By / Updated By */}
                <li>
                  <span className="dropdown-item-text text-muted">
                    <FontAwesomeIcon icon={faPlus} />{" "}
                    {row.original.createdBy
                      ? `${row.original.createdBy} (${row.original.created_at
                        ? moment(row.original.created_at).format(
                          "DD-MMM-YY hh:mm A"
                        )
                        : ""
                      })`
                      : ""}
                  </span>
                </li>
                {row.original.updatedAt && (
                  <li>
                    <span className="dropdown-item-text text-muted">
                      <FontAwesomeIcon icon={faPen} />{" "}
                      {row.original.updatedAt
                        ? `${row.original.updatedBy} (${row.original?.updatedAt
                          ? moment(row.original?.updatedAt).format(
                            "DD-MMM-YY hh:mm A"
                          )
                          : ""
                        })`
                        : ""}
                    </span>
                  </li>
                )}
                {row.original.approvedBy && (
                  <li>
                    <span className="dropdown-item-text text-muted">
                      <FontAwesomeIcon icon={faCheckCircle} />{" "}
                      {row.original.approvedBy
                        ? `${row.original.approvedBy} (${row.original?.approvedAt
                          ? moment(row.original?.approvedAt).format(
                            "DD-MMM-YY hh:mm A"
                          )
                          : ""
                        })`
                        : ""}
                    </span>
                  </li>
                )}
              </ul>
            </div>
          ),
        },
      ],
      [permissions]
    );

    return <TableComponent columns={columns} data={completedData} />;
  };
  useEffect(() => {
    fetchPersons();
  }, []);
  const fetchPersons = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getApprovers`, {
        // Assuming there's an endpoint to fetch persons
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setPersonOptions(
        response.data.map((person) => ({
          value: person.id,
          label: `${person.firstName} ${person.lastName} - ${person.contactNo}`, // Assuming 'firstName' and 'lastName' are available
          mobileNo: person.contactNo,
          badgeId: person.badgeId,
          position: person.position,
          sewadarOf: person.sewadarOf,
        }))
      );
    } catch (error) {
      console.error("Error fetching persons for approval:", error);
    }
  };

  const handleView = (row) => {
    navigate("../../IssueRequestPreview", { state: { id: row.id } });
  };
  const handleApprove = (id) => {
    Swal.fire({
      title: "Enter your PIN",
      input: "password",
      inputPlaceholder: "Enter your PIN",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Submit",
      inputValidator: (value) => {
        if (!value) {
          return "Please enter your PIN.";
        }
        if (value !== pin) {
          return "Invalid PIN. Please try again.";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const approvedBy = name;
        const approvedByBadge = badgeId;

        apiClient
          .post(`${SERVER_BASE}/approveIssueRequest/${id}`, {
            approvedBy,
            approvedByBadge,
          })
          .then(() => {
            Swal.fire({
              icon: "success",
              title: "Voucher Approved!",
              text: "The voucher has been approved successfully.",
              confirmButtonText: "OK",
            }).then(() => { });
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: `Failed to approve the voucher: ${err.response?.data?.message || err.message
                }`,
              confirmButtonText: "OK",
            });
          });
      }
    });
  };
  const handleSendForApproval = (draftId, department) => {
    if (!token) {
      window.location.href = "/";
      return;
    }

    setDraftID(draftId);
    setDepartmentForModal(department);
    setModalShow(true);
  };
  const handleModalSubmit = async (personId) => {
    const selectedPerson = personOptions.find(
      (person) => String(person.value) === String(personId)
    );
    const mobileNo = selectedPerson?.mobileNo;
    try {
      // API call to send for approval
      await apiClient.post(
        `${SERVER_BASE}/sendForApproval/${draftId}`,
        { personId, type: "issueRequest" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const baseLink = `https://rs.iosystem.in/IssueRequestPreview?id=${draftId}`;
      const fullLink = `${baseLink}&draftId=${draftId}&personId=${personId}&type=issueRequest`;
      const whatsappLink = `https://wa.me/${mobileNo}?text=${encodeURIComponent(
        `Please Approve this Issue Request: ${fullLink}`
      )}`;
      window.open(whatsappLink, "_blank");

      setModalShow(false); // Close modal after successful submission
    } catch (error) {
      console.error("Error sending for approval:", error);
      setModalShow(false); // Close modal on error
    }
  };
  const getFilteredOptions = () => {
    return personOptions.filter(
      (person) =>
        person.position === "Authorized Person" ||
        person.sewadarOf === departmentForModal
    );
  };
  return (
    <div className="formcontainer mt-5">
      <h3 className="mb-3">Issue Request</h3>
      <div className="d-flex justify-content-between">
        <div>

          {permissions?.write && (
            <>
              <button
                onClick={() => {
                  navigate("../issueRequestPage", {
                    state: { type: 'Own' },
                  });
                }}
                className="btn btn-outline-success me-2"
              >
                For Own Department
              </button>
              <button
                onClick={() => {
                  navigate("../issueRequestPage", {
                    state: { type: 'Other' },
                  });
                }}
                className="btn btn-outline-success"
              >
                Behalf of other Department
              </button>
            </>
          )}
        </div>
        <button
          className="btn btn-outline-primary"
          onClick={() =>
            navigate("../../DepartmentIssueRequestReport", {
              state: { accessOfDepartments }
            })
          }
        >
          Get Report
        </button>
      </div>
      {permissions?.read && (
        <>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "table1" ? "active" : ""}`}
                onClick={() => setActiveTab("table1")}
              >
                Pending Requests
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "table2" ? "active" : ""}`}
                onClick={() => setActiveTab("table2")}
              >
                Completed Requests
              </button>
            </li>
          </ul>
          <div className="tab-content mt-4">
            {activeTab === "table1" && (
              <div className="tab-pane fade show active">
                <Table1 />
              </div>
            )}
            {activeTab === "table2" && (
              <div className="tab-pane fade show active">
                <Table2 />
              </div>
            )}
          </div>
          <ApproverModal
            show={modalShow}
            title="Send for Approval"
            options={getFilteredOptions()}
            close={closeModal} // Pass close function
            onSubmit={handleModalSubmit}
          />
        </>
      )}
    </div>
  );
};

export default IssueRequestTable;
